export enum ProfileDataTypes {
    REQUEST_PACKAGE_SUMMARIES = "REQUEST_PACKAGE_SUMMARIES",
    SET_PACKAGE_SUMMARIES = "SET_PACKAGE_SUMMARIES",

    SHOW_USER_PACKAGES_LOADING = "SHOW_USER_PACKAGES_LOADING",
    HIDE_USER_PACKAGES_LOADING = "HIDE_USER_PACKAGES_LOADING",
    REQUEST_LOAD_USER_PACKAGES = "REQUEST_LOAD_USER_PACKAGES",
    SET_USER_PACKAGES_DATA = "SET_USER_PACKAGES_DATA",

    GET_USER_DEVICES = "GET_USER_DEVICES",
    SET_USER_DEVICES = "SET_USER_DEVICES",
    REQUEST_ACCESS_CODE = "REQUEST_ACCESS_CODE",
    CONNECT_CURRENT_DEVICE_CONFIRM_CODE = "CONNECT_CURRENT_DEVICE_CONFIRM_CODE",
    CUT_ALL_DEVICE_CONFIRM_CODE = "CUT_ALL_DEVICE_CONFIRM_CODE",
    ACCESS_CODE_SENT = "ACCESS_CODE_SENT",
    CLEAR_ACCESS_CODE_INFO = "CLEAR_ACCESS_CODE_INFO",
    ACCESS_TOGGLED = "ACCESS_TOGGLED",
    ACCESS_NOT_TOGGLED = "ACCESS_NOT_TOGGLED",

    REQUEST_USER_FAVORITES = "REQUEST_USER_FAVORITES",
    SET_USER_FAVORITES = "SET_USER_FAVORITES",
    SEARCH_FOR_FAVORITES = "SEARCH_FOR_FAVORITES",
    SET_FAVORITES_SEARCH_RESULT = "SET_FAVORITES_SEARCH_RESULT",
    ADD_FAVORITE_ITEM = "ADD_FAVORITE_ITEM",
    REMOVE_FAVORITE_ITEM = "REMOVE_FAVORITE_ITEM",
    CLEAR_FAVORITE_ACTION_LOADING = "CLEAR_FAVORITE_ACTION_LOADING"
}